import {
  OVERVIEW_ACTIVE,
  OVERVIEW_INACTIVE,
  FOLDER_ACTIVE,
  FOLDER_INACTIVE,
  PAYMENT_ACTIVE,
  PAYMENT_INACTIVE,
  NOTIFICATION_ACTIVE,
  NOTIFICATION_INACTIVE,
  SETTING_ACTIVE,
  SETTING_INACTIVE,
  PANEL_ACTIVE,
  PANEL_INACTIVE,
} from "../../../../assets";

export const PresidentSidebarRoute = [
  {
    title: "Overview",
    activeIcon: OVERVIEW_ACTIVE,
    inactiveIcon: OVERVIEW_INACTIVE,
    path: "/president/overview",
  },
  {
    title: "Case Folders",
    activeIcon: FOLDER_ACTIVE,
    inactiveIcon: FOLDER_INACTIVE,
    path: "/president/case-folders",
  },
  {
    title: "Panels",
    activeIcon: PANEL_ACTIVE,
    inactiveIcon: PANEL_INACTIVE,
    path: "/president/panels",
  },
  {
    title: "Cause Lists",
    activeIcon: PAYMENT_ACTIVE,
    inactiveIcon: PAYMENT_INACTIVE,
    path: "/president/cause-lists",
  },

  {
    title: "Notification",
    activeIcon: NOTIFICATION_ACTIVE,
    inactiveIcon: NOTIFICATION_INACTIVE,
    path: "/president/notification",
  },
  {
    title: "Setting",
    activeIcon: SETTING_ACTIVE,
    inactiveIcon: SETTING_INACTIVE,
    path: "/president/setting",
  },
];
